import { useDatabase } from '../composables/database'
import { StoresRows } from '../types/database'
import { DataRow } from '../types/components/data-rendering'

type StoresModelReturn = {
  // storesToSQLRows: (data: DataRow[]) => string
  getStores: () => Promise<DataRow[]>
  writeStores: (data: DataRow[], clearAll?: boolean) => Promise<void>
  /**Useful for deleting all stores from device during switchto/changing reps
   */
  clearStores: () => Promise<void>
}
export const StoresModel = (): StoresModelReturn => {
  const { query, run } = useDatabase()
  const queryStore = async (sql: string) => {
    return await query(sql).then((stores: StoresRows | void | null) => {
      if (stores && stores[0]) {
        return JSON.parse(stores[0]['stores_data'])
      } else {
        return []
      }
    })
  }

  const getStores = async () => {
    const sql = `
        SELECT * FROM stores;
        `
    return await queryStore(sql)
  }

  const writeStores = async (data: DataRow[]) => {
    let rows
    if (typeof data !== 'undefined') {
      rows = JSON.stringify(data)
    }

    const queryString = `
    INSERT OR REPLACE INTO stores
    ('id', 'last_updated', 'stores_data')
    VALUES (0, datetime(), ?);`

    const values = [rows]

    await run(queryString, values)
  }

  const clearStores = async () => {
    const sql = 'DELETE FROM stores;'
    await run(sql, []).catch((error) => console.log(`Error deleting stores: ${error}`))
  }

  return {
    // storesToSQLRows,
    getStores,
    writeStores,
    clearStores,
  }
}
